/* ZCT_V22_LADEN (E1): Warenkorb und Merkliste für die Liquid-Seiten von ZinCuTec v22.
   Verhalten wie die React-App in v21 (App: addToCart, updateQty, saveCartNote; CartDrawer; WishDrawer):
   - Zeile und Zähler sofort (optimistisch), Schublade öffnet nach dem Laden des Produktbilds, spätestens nach 300 ms.
   - Mengen je Zeile in einer Warteschlange (spätere Klicks überholen frühere, nur der letzte Wert wird gesendet).
   - Fehler: still zurückrollen (J12, wie v21). Abgelehnt (4xx) = zurück auf den gesicherten Stand;
     unklar (Netz, 5xx, Frist) = Warenkorb neu lesen statt raten (Mechanik nach back to ctrl). Nie automatisch wiederholen.
   - Jede Anfrage hat eine Frist von 12 s inklusive Antwortkörper.
   - Bestellnotiz speichert 700 ms nach der letzten Eingabe, beim Verlassen des Felds sofort, vor der Kasse sicher.
   - Merkliste im Browser gespeichert (localStorage zincutec:wish, J10).
   - Warenkorb-Seite (/cart, E5): der Server zeichnet sie fertig, <zct-warenkorb-seite> übernimmt mit demselben Zustand.
   Öffentliche Schnittstelle: window.zctLaden (add, quickAdd, toggleWish, openCart, openWish, ...). */
(function () {
  'use strict';
  // Bewegung komplett: Zeit-Token lesen; Shopify liefert das CSS verkleinert aus (200ms wird .2s), daher Sekunden und Millisekunden
  function zdZeit(v) { v = String(v || '').trim(); var x = parseFloat(v); if (isNaN(x)) return NaN; return /ms$/i.test(v) ? x : (/s$/i.test(v) ? x * 1000 : x); }
  if (window.zctLaden) return;

  var FRIST = 12000;
  var WISH_KEY = 'zincutec:wish';

  function json(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  var PRODUKTE = json('zct-produkte') || [];
  var TEXTE = json('zct-texte') || {};
  // Warenkorb-Aufrufe in der Seitensprache (/en/cart.js usw.): Shopify liefert Titel und Variantenwerte dann so, wie sie auch in
  // der Kasse stehen (Stopp 2, Entscheidung 2). Auf Deutsch ist ROOT leer, also wie bisher /cart.js.
  var ROOT = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');

  // Shopify maskiert HTML-Zeichen in Übersetzungen (z. B. &amp;), hier einmal zurückverwandeln; esc() maskiert beim Einsetzen
  function entschluesseln(s) { if (typeof s !== 'string' || s.indexOf('&') < 0) return s; var t = document.createElement('textarea'); t.innerHTML = s; return t.value; }
  function tx(schluessel) { return TEXTE[schluessel] != null ? entschluesseln(TEXTE[schluessel]) : schluessel; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fmt(n) {
    if (n == null) return null;
    var waehrung = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    return new Intl.NumberFormat(tx('v25_intl_geld'), { style: 'currency', currency: waehrung, maximumFractionDigits: 2, useGrouping: 'always' }).format(n);
  }
  function produkt(id) {
    for (var i = 0; i < PRODUKTE.length; i++) if (PRODUKTE[i].id === id || PRODUKTE[i].handle === id) return PRODUKTE[i];
    return null;
  }
  function istShopifyBild(url) { return !!url && /(?:cdn\.shopify\.com|\/cdn\/shop\/)/.test(url); }
  function bildUrl(url, w) {
    try {
      if (!istShopifyBild(url)) return url;
      var u = new URL(url, location.origin);
      u.searchParams.set('width', String(w));
      return u.toString();
    } catch (e) { return url; }
  }
  var STANDARD_BREITEN = [360, 540, 720, 960, 1200, 1600];
  var STANDARD_SIZES = '(max-width: 680px) 92vw, (max-width: 1100px) 48vw, 560px';
  function bildSet(url, breiten) {
    breiten = breiten || STANDARD_BREITEN;
    return istShopifyBild(url) ? breiten.map(function (w) { return bildUrl(url, w) + ' ' + w + 'w'; }).join(', ') : '';
  }
  // Wie die Ph-Komponente (div.ph.has-img > img)
  function ph(src, alt, loading, ton) {
    if (!src) return '<div class="ph ' + esc(ton || 'brass') + ' "></div>';
    var set = bildSet(src);
    return '<div class="ph has-img "><img src="' + esc(bildUrl(src, 1600)) + '"' + (set ? ' srcset="' + esc(set) + '"' : '') +
      ' sizes="' + STANDARD_SIZES + '" alt="' + esc(alt || '') + '" loading="' + (loading || 'lazy') + '" decoding="async" referrerpolicy="no-referrer"></div>';
  }
  function icon(name) {
    var p = {
      close: '<path d="M3 3l10 10M13 3L3 13"></path>',
      minus: '<path d="M3 8h10"></path>',
      plus: '<path d="M8 3v10M3 8h10"></path>',
      arrow: '<path d="M3 8h10m-4-4l4 4-4 4"></path>'
    };
    return '<svg class="ico " viewBox="0 0 16 16">' + (p[name] || '') + '</svg>';
  }

  // ---------- DOM nur dort ändern, wo sich etwas geändert hat (wie React; Bilder flackern nicht) ----------
  // Zeilen tragen beim Bauen data-zct-k (Schlüssel); er wird als Eigenschaft gemerkt und aus dem HTML entfernt.
  // Server (image_url) und Warenkorb-Daten nennen dieselbe Datei verschieden (zincutec.eu/cdn/shop/files/… gegen
  // cdn.shopify.com/s/files/…/files/…, mit ?v=): gleiche Datei und Breite gilt als gleiches Bild, die Adresse bleibt (kein Neuladen).
  function bildSchluessel(u) {
    return String(u || '').replace(/(?:https?:)?\/\/(?:cdn\.shopify\.com\/s\/files\/\d+\/\d+\/\d+\/\d+|[^\/\s,]+\/cdn\/shop)\//g, '')
      .replace(/([?&])v=\d+(&?)/g, function (m, a, b) { return b ? a : ''; });
  }
  function schluesselMerken(wurzel) {
    wurzel.querySelectorAll('[data-zct-k]').forEach(function (el) { el._zctK = el.getAttribute('data-zct-k'); el.removeAttribute('data-zct-k'); });
  }
  function morph(alt, neu) {
    if (alt.nodeType !== neu.nodeType || alt.nodeName !== neu.nodeName) { alt.replaceWith(neu); return; }
    if (alt.nodeType === 3 || alt.nodeType === 8) { if (alt.nodeValue !== neu.nodeValue) alt.nodeValue = neu.nodeValue; return; }
    if (alt.nodeType !== 1) return;
    Array.prototype.slice.call(alt.attributes).forEach(function (a) { if (!neu.hasAttribute(a.name)) alt.removeAttribute(a.name); });
    Array.prototype.slice.call(neu.attributes).forEach(function (a) {
      var bisher = alt.getAttribute(a.name);
      if (bisher === a.value) return;
      if (alt.tagName === 'IMG' && (a.name === 'src' || a.name === 'srcset') && bisher != null && bildSchluessel(bisher) === bildSchluessel(a.value)) return;
      alt.setAttribute(a.name, a.value);
    });
    if (alt.tagName === 'TEXTAREA') { if (document.activeElement !== alt && alt.value !== neu.value) alt.value = neu.value; return; }
    var a = Array.prototype.slice.call(alt.childNodes);
    var n = Array.prototype.slice.call(neu.childNodes);
    var mitSchluessel = n.some(function (x) { return x.nodeType === 1 && x.hasAttribute('data-zct-k'); });
    if (mitSchluessel) {
      var karte = new Map();
      a.forEach(function (x) { if (x._zctK) karte.set(x._zctK, x); });
      var ergebnis = n.map(function (x) {
        if (x.nodeType === 1 && x.hasAttribute('data-zct-k')) {
          var k = x.getAttribute('data-zct-k'); x.removeAttribute('data-zct-k');
          var o = karte.get(k);
          if (o) { karte.delete(k); morph(o, x); return o; }
          schluesselMerken(x); x._zctK = k; return x;
        }
        return x;
      });
      a.forEach(function (x) { if (ergebnis.indexOf(x) < 0) x.remove(); });
      ergebnis.forEach(function (x, i) { if (alt.childNodes[i] !== x) alt.insertBefore(x, alt.childNodes[i] || null); });
      return;
    }
    for (var i = 0; i < n.length; i++) {
      if (i < a.length) morph(a[i], n[i]);
      else { schluesselMerken(n[i].nodeType === 1 ? n[i] : document.createElement('i')); alt.appendChild(n[i]); }
    }
    for (var j = a.length - 1; j >= n.length; j--) a[j].remove();
  }
  function einsetzen(behaelter, html) {
    var neu = behaelter.cloneNode(false);
    neu.innerHTML = html;
    if (!behaelter._zctGezeichnet) {
      behaelter.innerHTML = html; schluesselMerken(behaelter); behaelter._zctGezeichnet = true; return;
    }
    morph(behaelter, neu);
  }

  // ---------- Netz ----------
  function anfrage(url, optionen) {
    var steuerung = new AbortController();
    var uhr = setTimeout(function () { steuerung.abort(); }, FRIST);
    var o = Object.assign({}, optionen || {}, { signal: steuerung.signal, credentials: 'same-origin' });
    return fetch(url, o).then(function (antwort) {
      // Frist gilt bis der Antwortkörper da ist (nicht nur bis zu den Kopfzeilen)
      return antwort.text().then(function (text) {
        var daten = null;
        try { daten = text ? JSON.parse(text) : null; } catch (e) { daten = undefined; }
        return { status: antwort.status, ok: antwort.ok, daten: daten };
      });
    }).finally(function () { clearTimeout(uhr); });
  }
  // abgelehnt: Shopify hat sicher nichts geändert (4xx mit lesbarer Antwort); unklar: alles andere
  function einordnen(r) {
    if (r.ok && r.daten) return { ok: true, daten: r.daten };
    if (r.status >= 400 && r.status < 500 && r.daten !== undefined) return { ok: false, abgelehnt: true, daten: r.daten };
    return { ok: false, abgelehnt: false };
  }
  function senden(url, body) {
    return anfrage(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(einordnen, function () { return { ok: false, abgelehnt: false }; });
  }
  function warenkorbLesen() {
    return anfrage(ROOT + '/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(einordnen, function () { return { ok: false, abgelehnt: false }; });
  }

  // ---------- Zustand ----------
  var roh = json('zct-warenkorb-daten') || { items: [], total_price: 0, item_count: 0, note: '' };
  var notiz = typeof roh.note === 'string' ? roh.note : '';
  var notizGespeichert = notiz;
  var notizStatus = 'idle';
  var notizUhr = null;
  var notizKette = Promise.resolve();
  var mengenSchlangen = new Map();
  var warenkorbOffen = false;
  var merklisteOffen = false;
  var merkliste = [];
  try { var gespeichert = JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); if (Array.isArray(gespeichert)) merkliste = gespeichert.filter(function (id) { return typeof id === 'string'; }); } catch (e) {}

  function kopie(c) { try { return JSON.parse(JSON.stringify(c)); } catch (e) { return null; } }
  function neuSummieren(c) {
    var items = (c && c.items) || [];
    var summe = 0, anzahl = 0;
    items = items.map(function (i) {
      var lp = (i.price || 0) * (i.quantity || 0);
      summe += lp; anzahl += (i.quantity || 0);
      return Object.assign({}, i, { line_price: lp, final_line_price: lp, original_line_price: lp });
    });
    return Object.assign({}, c, { items: items, item_count: anzahl, items_subtotal_price: summe, total_price: summe, original_total_price: summe });
  }
  // wie normalizeShopifyCartItems in v21
  function zeilen() {
    return ((roh && roh.items) || []).map(function (item, i) {
      var p = produkt(item.handle);
      var img = (item.featured_image && item.featured_image.url) || item.image || (p && p.img);
      var vt = (item.variant_title || '').split(' / ');
      return {
        key: item.key, line: i + 1, id: item.handle || (p && p.id) || item.product_id, productId: item.product_id,
        variantId: item.variant_id, name: item.product_title || item.title, tone: (p && p.ton) || 'brass', img: img,
        price: (item.final_price != null ? item.final_price : (item.price != null ? item.price : 0)) / 100,
        alt: (item.original_price != null ? item.original_price : (item.price != null ? item.price : 0)) / 100,
        size: vt[0] || '', finish: vt.slice(1).join(' / ') || '', qty: item.quantity
      };
    });
  }
  // Zeilen-Schlüssel wie in v21 (React key: variantId): die Zeile bleibt dieselbe, wenn aus der vorläufigen Zeile die echte wird
  // (kein Neuaufbau, Bild flackert nicht). Gleiche Variante mehrfach (z. B. Gutscheine an verschiedene Empfänger) wird durchgezählt.
  function zeilenSchluessel(ls) {
    var n = {};
    return ls.map(function (l, i) { var v = String(l.variantId || l.key || i); n[v] = (n[v] || 0) + 1; return v + ':' + (n[v] - 1); });
  }
  function variante(l) {
    var s = l.size || '', f = l.finish || '';
    if (!f) return s;
    if (!s) return f;
    return f.indexOf(s) >= 0 ? f : s + ' · ' + f;
  }
  // Mengenrabatt (RYU, JIKU ab 3 Stück): Shopify rechnet den automatischen Rabatt in final_price ein, dann steht der Originalpreis durchgestrichen darüber
  function preisZelle(l) {
    var neu = l.price * l.qty, alt = l.alt * l.qty;
    return (alt - neu > 0.004 ? '<s class="zd-preis-alt">' + esc(fmt(alt)) + '</s>' : '') + esc(fmt(neu));
  }
  // wie resolveVariantId in v21
  function varianteFinden(item) {
    if (typeof item === 'number' || typeof item === 'string') return item;
    if (!item) return null;
    if (item.variantId) return item.variantId;
    var p = produkt(item.id);
    if (!p || !p.varianten || !p.varianten.length) return null;
    var vs = p.varianten;
    if (item.size || item.tone) {
      var df = { steel: 'Edelstahl, gebürstet', brass: 'Messing, brüniert' };
      var wf = (item.tone && df[item.tone]) ? df[item.tone] : (item.finish || null);
      var sz = (item.size != null) ? String(item.size) : null;
      var m = vs.find(function (v) { return (sz == null || v.o1 === sz) && (wf == null || v.o2 === wf || v.o2 == null); });
      if (!m && wf) m = vs.find(function (v) { return (sz == null || v.o1 === sz) && v.o2 && v.o2.indexOf(wf) >= 0; });
      if (!m && sz != null) m = vs.find(function (v) { return v.o1 === sz; });
      if (!m) m = vs.find(function (v) { return v.t && (sz == null || v.t.indexOf(sz) >= 0) && (wf == null || v.t.indexOf(wf) >= 0); });
      if (!m && item.tone) {
        var woerter = item.tone === 'brass' ? ['messing', 'brass', 'laiton', 'latón', 'ottone'] : ['edelstahl', 'stainless', 'steel', 'acier', 'acero', 'acciaio'];
        m = vs.find(function (v) { var heu = [v.t, v.o1, v.o2].filter(Boolean).join(' ').toLowerCase(); return woerter.some(function (w) { return heu.indexOf(w) >= 0; }); });
      }
      if (m) return m.id;
    }
    var lieferbar = vs.find(function (v) { return v.a !== false; });
    return (lieferbar && lieferbar.id) || (vs[0] && vs[0].id) || null;
  }

  // ---------- Darstellung ----------
  var zuhoerer = [];
  // Bewegung komplett (Plan 013): kurzer Puls als Bestätigung (Zähler, Merken-Herz), scale .9 -> 1 in --zd-dauer-druck, --zd-kurve-aus;
  // additiv zum vorhandenen transform; „Bewegung reduzieren“: kein Puls
  window.zctPuls = function (el) {
    if (!el || !el.animate || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    var rs = getComputedStyle(document.documentElement);
    el.animate([{ transform: 'scale(.9)' }, { transform: 'scale(1)' }], { duration: zdZeit(rs.getPropertyValue('--zd-dauer-druck')) || 160, easing: (rs.getPropertyValue('--zd-kurve-aus') || '').trim() || 'ease-out', composite: 'add' });
  };
  var anzahlVorher = null, merkVorher = null;
  function melden() {
    var anzahl = zeilen().reduce(function (s, l) { return s + l.qty; }, 0);
    var pulsW = anzahlVorher !== null && anzahl !== anzahlVorher && anzahl > 0, pulsM = merkVorher !== null && merkliste.length !== merkVorher && merkliste.length > 0;
    anzahlVorher = anzahl; merkVorher = merkliste.length;
    // ZCT_V26: data-leer bei 0 (am Rechner ohne Zahl-Punkt wie in Figma, Handy unverändert)
    document.querySelectorAll('[data-zct-warenkorb-zahl]').forEach(function (el) { el.textContent = String(anzahl); el.toggleAttribute('data-leer', anzahl === 0); if (pulsW) window.zctPuls(el); });
    document.querySelectorAll('[data-zct-merkliste-zahl]').forEach(function (el) {
      el.textContent = String(merkliste.length || 0);
      if (merkliste.length === 0) el.style.visibility = 'hidden'; else el.style.removeProperty('visibility');
      if (pulsM) window.zctPuls(el);
      if (!el.getAttribute('style')) el.removeAttribute('style');
    });
    document.querySelectorAll('[data-zct-merkliste-om]').forEach(function (btn) {
      var sp = btn.querySelector('.cart-count');
      if (merkliste.length > 0) {
        if (!sp) { sp = document.createElement('span'); sp.className = 'cart-count'; btn.appendChild(sp); }
        sp.textContent = String(merkliste.length);
      } else if (sp) sp.remove();
    });
    zuhoerer.forEach(function (f) { try { f(); } catch (e) {} });
    window.dispatchEvent(new CustomEvent('zct:laden', { detail: { warenkorb: roh, merkliste: merkliste.slice() } }));
  }

  function notizHtml(id, kompakt) {
    var text = notizStatus === 'saving' ? tx('notiz_speichert') : notizStatus === 'saved' ? tx('notiz_gespeichert') : notizStatus === 'error' ? tx('notiz_fehler') : '';
    return '<div class="cart-note ' + (kompakt ? 'cart-note-compact' : '') + '"><label class="cart-note-label" for="' + id + '">' + esc(tx('notiz_titel')) + '<span>' + esc(tx('notiz_optional')) + '</span></label>' +
      '<textarea id="' + id + '" name="note" class="cart-note-textarea" rows="' + (kompakt ? 2 : 3) + '" maxlength="1000" placeholder="' + esc(tx('notiz_platzhalter')) + '" aria-describedby="' + id + '-help ' + id + '-status">' + esc(notiz) + '</textarea>' +
      '<div class="cart-note-meta"><span id="' + id + '-help" class="cart-note-help">' + esc(tx('notiz_hilfe')) + '</span>' +
      '<span id="' + id + '-status" class="cart-note-status ' + notizStatus + '" role="' + (notizStatus === 'error' ? 'alert' : 'status') + '" aria-live="polite">' + esc(text) + '</span></div></div>';
  }

  // Zwischensumme und Lieferung (alle Objekte versandkostenfrei), Empfehlungen = erste Objekte mit Preis, die fehlen
  function summen(ls) {
    var zwischen = ls.reduce(function (s, l) { return s + l.price * l.qty; }, 0);
    var versand = 0;
    return { zwischen: zwischen, versand: versand, gesamt: zwischen + versand };
  }
  function empfehlungen(ls, n) {
    return PRODUKTE.filter(function (p) { return !ls.find(function (l) { return l.id === p.id; }) && p.preis; }).slice(0, n);
  }
  function pflegeLink() {
    return '<a href="' + (ROOT + '/pages/pflege') + '" data-zct-zu-link style="display: inline-flex; align-items: center; justify-content: space-between; gap: 8px; color: inherit; font-size: 12px; text-decoration: underline; text-underline-offset: 3px; margin: 2px 0px 10px;">' + esc(tx('pflege_schublade')) + icon('arrow') + '</a>';
  }
  function kasseLink(gesamt) {
    return '<a class="btn brass" href="/checkout" data-zct-kasse style="text-align: center; text-decoration: none;">' + esc(tx('zur_kasse')) + ' · ' + esc(fmt(gesamt)) + ' ' + icon('arrow') + '</a>';
  }
  function sicherZeile(klasse) {
    return '<div class="' + klasse + '"><span>' + esc(tx('ssl')) + '</span><span>·</span><span>' + esc(tx('mwst')) + '</span><span>·</span><span>Klarna</span></div>';
  }

  function warenkorbInnen() {
    var ls = zeilen();
    var sm = summen(ls), zwischen = sm.zwischen, versand = sm.versand, gesamt = sm.gesamt;
    var empfehlung = empfehlungen(ls, 1);
    var h = '<div class="dh"><div class="zct-drawer-title">' + esc(tx('deine_auswahl')) + ' <span style="color: var(--ink-3); font-size: 14px; margin-left: 6px;">(' + ls.length + ')</span></div>' +
      '<button aria-label="' + esc(tx('schliessen')) + '" data-zct-zu>' + icon('close') + '</button></div><div class="items">';
    if (ls.length === 0) h += '<div style="padding: 40px 0px; text-align: center; color: var(--ink-3); font-size: 14px;">' + esc(tx('leer_1')) + '<br>' + esc(tx('leer_2')) + '</div>';
    var sk = zeilenSchluessel(ls);
    ls.forEach(function (l, i) {
      h += '<div class="li" data-zct-k="' + esc(sk[i]) + '"><div class="th">' + ph(l.img, l.name || '', 'eager', l.tone) + '</div><div class="body"><div class="nm">' + esc(l.name) + '</div><div class="v">' + esc(variante(l)) + '</div>' +
        '<div class="qc"><button aria-label="' + esc(tx('weniger')) + '" data-zct-menge="' + i + '" data-zct-wert="' + (l.qty - 1) + '">' + icon('minus') + '</button><div class="n">' + l.qty + '</div>' +
        '<button aria-label="' + esc(tx('mehr')) + '" data-zct-menge="' + i + '" data-zct-wert="' + (l.qty + 1) + '">' + icon('plus') + '</button></div>' +
        '<button type="button" class="rm" data-zct-menge="' + i + '" data-zct-wert="0">' + esc(tx('entfernen')) + '</button></div><div class="price">' + preisZelle(l) + '</div></div>';
    });
    h += '</div>';
    if (ls.length > 0) {
      h += '<div class="upsell"><div class="zct-upsell-label">' + esc(tx('oft_dazu')) + '</div>';
      empfehlung.forEach(function (p) {
        h += '<div class="u" data-zct-k="u-' + esc(p.id) + '" style="margin-bottom: 10px;"><div class="th">' + ph(p.img, p.name || '', 'lazy', p.ton) + '</div><div><div class="nm">' + esc(p.name) + '</div><div class="p">' + esc(tx('ab')) + ' ' + esc(fmt(p.preis / 100)) + '</div></div>' +
          '<button class="add" data-zct-empfehlung="' + esc(p.id) + '">' + esc(tx('hinzu')) + '</button></div>';
      });
      h += '</div>';
    }
    h += '<div class="foot"><div class="row"><span>' + esc(tx('zwischensumme')) + '</span><span>' + esc(fmt(zwischen)) + '</span></div>' +
      '<div class="row"><span>' + esc(tx('lieferung')) + '</span><span>' + esc(versand ? fmt(versand) : tx('kostenlos')) + '</span></div>' +
      '<div class="tot"><span>' + esc(tx('gesamt')) + '</span><span>' + esc(fmt(gesamt)) + '</span></div>' + notizHtml('zct-notiz-schublade', true) +
      kasseLink(gesamt) + '</div>';
    return h;
  }

  // Warenkorb-Seite wie CartPage in v21 (gleiche Zeilen und Summen wie die Schublade, drei Empfehlungen, große Notiz)
  function seiteInnen() {
    var ls = zeilen();
    var sm = summen(ls);
    var h = '<div class="cart-page"><div class="cart-page-inner"><div class="cart-page-header"><div class="eyebrow">' + esc(tx('warenkorb')) + '</div><h1>' + esc(tx('deine_auswahl')) +
      ' <span class="cart-page-count">(' + ls.length + ')</span></h1></div>';
    if (ls.length === 0) {
      h += '<div class="cart-page-empty"><p>' + esc(tx('leer_1')) + '</p><p>' + esc(tx('leer_2')) + '</p><button class="btn" data-zct-href="' + esc(ROOT + '/collections/alle-pieces') + '">' + esc(tx('shop_produkte')) + ' ' + icon('arrow') + '</button></div>';
      return h + '</div></div>';
    }
    h += '<div class="cart-page-items">';
    var sk = zeilenSchluessel(ls);
    ls.forEach(function (l, i) {
      h += '<div class="cart-page-li" data-zct-k="' + esc(sk[i]) + '"><div class="cart-page-img">' + ph(l.img, l.name || '', 'eager', l.tone) + '</div><div class="cart-page-body"><div class="cart-page-name">' + esc(l.name) + '</div>' +
        '<div class="cart-page-variant">' + esc(variante(l)) + '</div><div class="cart-page-qc"><button aria-label="' + esc(tx('weniger')) + '" data-zct-menge="' + i + '" data-zct-wert="' + (l.qty - 1) + '">' + icon('minus') + '</button>' +
        '<div class="cart-page-qn">' + l.qty + '</div><button aria-label="' + esc(tx('mehr')) + '" data-zct-menge="' + i + '" data-zct-wert="' + (l.qty + 1) + '">' + icon('plus') + '</button></div>' +
        '<button type="button" class="cart-page-rm" data-zct-menge="' + i + '" data-zct-wert="0">' + esc(tx('entfernen')) + '</button></div><div class="cart-page-price">' + preisZelle(l) + '</div></div>';
    });
    h += '</div>';
    var empfehlung = empfehlungen(ls, 3);
    if (empfehlung.length) {
      h += '<div class="cart-page-upsell"><div class="zct-upsell-label">' + esc(tx('oft_dazu')) + '</div><div class="cart-page-upsell-grid">';
      empfehlung.forEach(function (p) {
        var href = ROOT + '/products/' + encodeURIComponent(p.handle || p.id);
        h += '<div class="cart-page-u" data-zct-k="u-' + esc(p.id) + '"><a href="' + esc(href) + '" class="cart-page-u-img" style="cursor: pointer;">' + ph(p.img, p.name || '', 'lazy', p.ton) + '</a>' +
          '<div class="cart-page-u-info"><div class="cart-page-u-name">' + esc(p.name) + '</div><div class="cart-page-u-price">' + esc(tx('ab')) + ' ' + esc(fmt(p.preis / 100)) + '</div></div>' +
          '<button class="cart-page-u-add" data-zct-empfehlung="' + esc(p.id) + '">' + esc(tx('hinzu')) + '</button></div>';
      });
      h += '</div></div>';
    }
    h += '<div class="cart-page-summary"><div class="cart-page-row"><span>' + esc(tx('zwischensumme')) + '</span><span>' + esc(fmt(sm.zwischen)) + '</span></div>' +
      '<div class="cart-page-row"><span>' + esc(tx('lieferung')) + '</span><span>' + esc(sm.versand ? fmt(sm.versand) : tx('kostenlos')) + '</span></div>' +
      '<div class="cart-page-total"><span>' + esc(tx('gesamt')) + '</span><span>' + esc(fmt(sm.gesamt)) + '</span></div>' + notizHtml('zct-notiz-seite', false) +
      pflegeLink().replace(' data-zct-zu-link', '') + kasseLink(sm.gesamt) + sicherZeile('cart-page-sec') + '</div>';
    return h + '</div></div>';
  }

  function merklisteInnen() {
    var items = merkliste.map(produkt).filter(Boolean);
    var h = '<div class="dh"><div class="zct-drawer-title">' + esc(tx('merkliste')) + ' <span style="color: var(--ink-3); font-size: 14px; margin-left: 6px;">(' + items.length + ')</span></div>' +
      '<button aria-label="' + esc(tx('schliessen')) + '" data-zct-zu>' + icon('close') + '</button></div><div class="items">';
    if (items.length === 0) h += '<div style="padding: 40px 0px; text-align: center; color: var(--ink-3); font-size: 14px;">' + esc(tx('merkliste_leer_1')) + '<br>' + esc(tx('merkliste_leer_2')) + '</div>';
    items.forEach(function (p) {
      var href = ROOT + '/products/' + encodeURIComponent(p.handle || p.id);
      h += '<div class="li" data-zct-k="' + esc(p.id) + '"><a href="' + esc(href) + '" class="th" style="cursor: pointer;">' + ph(p.img, p.name || '') + '</a><div class="body">' +
        '<a href="' + esc(href) + '" class="nm" style="cursor: pointer;">' + esc(p.name) + '</a><div class="v">' + esc(p.katText) + '</div>' +
        '<div class="pr" style="margin-top: 6px; font-size: 14px;">' + esc(p.preis ? fmt(p.preis / 100) : tx('auf_anfrage_merkliste')) + '</div>' +
        '<button type="button" class="rm" data-zct-merk-weg="' + esc(p.id) + '">' + esc(tx('entfernen')) + '</button></div>' +
        '<a href="' + esc(href) + '" class="btn sm ghost" style="align-self: center; flex-shrink: 0;">' + esc(tx('ansehen')) + '</a></div>';
    });
    h += '</div>';
    if (items.length > 0) h += '<div class="foot" style="border-top: 1px solid var(--line); padding-top: 20px;"><button class="btn" style="width: 100%; justify-content: center;" data-zct-zu>' + esc(tx('weiter')) + ' ' + icon('arrow') + '</button></div>';
    return h;
  }

  // ---------- Warenkorb-Vorgänge ----------
  function zusammenfuehren(echt, bilderAus) {
    // wie v21: Bilder der schon gezeigten Zeilen behalten
    var vorher = new Map();
    ((bilderAus && bilderAus.items) || []).forEach(function (pi) { if (!vorher.has(String(pi.variant_id))) vorher.set(String(pi.variant_id), pi); });
    var items = (echt.items || []).map(function (ri) {
      var pi = vorher.get(String(ri.variant_id));
      return pi ? Object.assign({}, ri, { featured_image: pi.featured_image, image: pi.image }) : ri;
    });
    return Object.assign({}, echt, { items: items });
  }
  function abgleichen(sicherung) {
    // unklarer Ausgang: Warenkorb vom Server lesen; nur wenn das scheitert, auf die Sicherung zurück
    return warenkorbLesen().then(function (r) {
      if (r.ok) { roh = zusammenfuehren(r.daten, roh); }
      else if (sicherung) { roh = sicherung; }
      melden();
    });
  }

  function hinzufuegen(zeile) {
    var vid = varianteFinden(zeile);
    var menge = Math.max(1, Number(zeile.qty) || 1);
    if (!vid) return Promise.resolve(null);
    var p = produkt(zeile.id);
    var sicherung = kopie(roh || { items: [], total_price: 0, item_count: 0 });
    var basis = roh || { items: [], total_price: 0, item_count: 0 };
    var idx = (basis.items || []).findIndex(function (i) { return String(i.variant_id || i.id) === String(vid); });
    var items;
    if (idx >= 0) {
      items = basis.items.map(function (item, j) { return j === idx ? Object.assign({}, item, { quantity: item.quantity + menge }) : item; });
    } else {
      var bild = zeile.img || (p && p.img) || '';
      items = [{
        id: Number(vid), variant_id: Number(vid), key: 'optimistic-' + vid + '-' + Date.now(), handle: (p && (p.handle || p.id)) || zeile.id,
        quantity: menge, title: zeile.name || (p && p.name) || 'Produkt', product_title: zeile.name || (p && p.name) || 'Produkt',
        variant_title: [zeile.size, zeile.finish].filter(Boolean).join(' / '),
        price: Math.round((zeile.price != null ? zeile.price : ((p && p.preis != null) ? p.preis / 100 : 0)) * 100),
        featured_image: { url: bild }, image: bild, url: p ? '/products/' + p.handle : '#', _optimistic: true
      }].concat(basis.items || []);
    }
    roh = neuSummieren(Object.assign({}, basis, { items: items }));
    melden();
    // Schublade öffnet, sobald das Produktbild bereit ist, spätestens nach 300 ms (wie v21) – und nur einmal
    // (Bewegung komplett, Plan 004: vorher bis zu dreimal, eine schnell geschlossene Schublade ging ungefragt wieder auf)
    var schonAuf = false;
    var auf = function () { if (schonAuf) return; schonAuf = true; warenkorbAuf(); };
    var vor = new Image();
    vor.onload = auf; vor.onerror = auf;
    vor.src = bildUrl(zeile.img || (p && p.img) || '', 480);
    if (vor.complete) auf();
    setTimeout(auf, 300);
    var koerper = { id: Number(vid), quantity: menge };
    if (zeile.properties) koerper.properties = zeile.properties; // z. B. Gutschein-Empfänger (E4, J17)
    return senden(ROOT + '/cart/add.js', koerper).then(function (r) {
      if (r.ok) {
        return warenkorbLesen().then(function (w) {
          if (w.ok) {
            var echt = w.daten;
            if (!roh || !roh.items || !roh.items.length) { roh = echt; }
            else {
              var nachVid = new Map();
              (echt.items || []).forEach(function (ri) { nachVid.set(String(ri.variant_id), ri); });
              var benutzt = new Set();
              var zusammen = roh.items.map(function (pi) {
                var vid2 = String(pi.variant_id); var ri = nachVid.get(vid2);
                if (ri && !benutzt.has(vid2)) { benutzt.add(vid2); return Object.assign({}, ri, { featured_image: pi.featured_image, image: pi.image }); }
                return pi;
              });
              nachVid.forEach(function (ri, v) { if (!benutzt.has(v)) zusammen.push(ri); });
              roh = Object.assign({}, echt, { items: zusammen });
            }
            melden();
          }
          return r.daten;
        });
      }
      // Fehler: still zurück wie in v21; bei unklarem Ausgang danach den echten Stand lesen (Shopify kann trotzdem gebucht haben)
      roh = sicherung; melden();
      if (r.abgelehnt) return null;
      return abgleichen(null).then(function () { return null; });
    });
  }

  function mengeAendern(index, wert) {
    var neu = Math.max(0, Number(wert) || 0);
    var ziel = ((roh && roh.items) || [])[Number(index)];
    if (!ziel) return;
    var key = ziel.key;
    var sicherung = kopie(roh);
    var items = (roh.items || []);
    items = neu === 0 ? items.filter(function (i) { return i.key !== key; }) : items.map(function (i) { return i.key === key ? Object.assign({}, i, { quantity: neu }) : i; });
    roh = neuSummieren(Object.assign({}, roh, { items: items }));
    melden();
    var schlange = mengenSchlangen.get(key);
    if (!schlange) { schlange = { offen: neu, sicherung: sicherung, laeuft: null }; mengenSchlangen.set(key, schlange); }
    else schlange.offen = neu;
    if (schlange.laeuft) return;
    schlange.laeuft = (function weiter() {
      if (schlange.offen === null) { mengenSchlangen.delete(key); return Promise.resolve(); }
      var zielMenge = schlange.offen; schlange.offen = null;
      return senden(ROOT + '/cart/change.js', { id: key, quantity: zielMenge }).then(function (r) {
        if (r.ok) {
          roh = zusammenfuehren(r.daten, roh);
          melden();
          return weiter();
        }
        schlange.offen = null; mengenSchlangen.delete(key);
        roh = schlange.sicherung; melden();
        if (r.abgelehnt) return;
        return abgleichen(null);
      });
    })();
  }

  function notizSpeichern(wert) {
    var n = String(wert == null ? notiz : wert).slice(0, 1000);
    notiz = n;
    if (notizUhr) { clearTimeout(notizUhr); notizUhr = null; }
    var lauf = function () {
      if (n === notizGespeichert) { if (notiz === n) { notizStatus = 'saved'; statusZeigen(); } return Promise.resolve(true); }
      if (notiz === n) { notizStatus = 'saving'; statusZeigen(); }
      return senden(ROOT + '/cart/update.js', { note: n }).then(function (r) {
        if (r.ok) {
          var gespeichert = typeof r.daten.note === 'string' ? r.daten.note : n;
          notizGespeichert = gespeichert;
          roh = zusammenfuehren(r.daten, roh);
          melden();
          if (notiz === n) { notiz = gespeichert; notizStatus = 'saved'; statusZeigen(); }
          return true;
        }
        if (notiz === n) { notizStatus = 'error'; statusZeigen(); }
        return false;
      });
    };
    var kette = notizKette.catch(function () { return true; }).then(lauf);
    notizKette = kette;
    return kette;
  }
  function notizAendern(wert) {
    notiz = String(wert == null ? '' : wert).slice(0, 1000);
    notizStatus = 'editing';
    statusZeigen();
    if (notizUhr) clearTimeout(notizUhr);
    var n = notiz;
    notizUhr = setTimeout(function () { notizSpeichern(n); }, 700);
  }
  function statusZeigen() {
    var text = notizStatus === 'saving' ? tx('notiz_speichert') : notizStatus === 'saved' ? tx('notiz_gespeichert') : notizStatus === 'error' ? tx('notiz_fehler') : '';
    document.querySelectorAll('.cart-note-status').forEach(function (el) {
      el.className = 'cart-note-status ' + notizStatus;
      el.setAttribute('role', notizStatus === 'error' ? 'alert' : 'status');
      el.textContent = text;
    });
    document.querySelectorAll('textarea.cart-note-textarea').forEach(function (ta) { if (document.activeElement !== ta && ta.value !== notiz) ta.value = notiz; });
  }

  // ---------- Schubladen ----------
  // E7 (Fokus): beim Öffnen springt der Fokus auf „Schließen“ in der Schublade, beim Schließen zurück zum auslösenden Element;
  // Escape schließt. Für Maus und Touch unsichtbar (kein Fokusrahmen nach Klick).
  var fokusVorher = null;
  function schubladeSetzen(wurzel, offen) {
    if (!wurzel) return;
    var bg = wurzel.querySelector('.drawer-bg');
    var dr = wurzel.querySelector('.drawer');
    bg.className = 'drawer-bg ' + (offen ? 'open' : '');
    dr.className = 'drawer ' + (offen ? 'open' : '');
    // Teil C3: Seite dahinter scrollt nicht mit, solange eine Schublade offen ist
    document.documentElement.classList.toggle('zd-gesperrt-schublade', !!document.querySelector('.drawer.open'));
    if (offen) {
      dr.setAttribute('role', 'dialog'); dr.setAttribute('aria-modal', 'true');
      dr.removeAttribute('aria-hidden'); dr.removeAttribute('inert');
      if (!dr.contains(document.activeElement)) fokusVorher = document.activeElement;
      var zu = dr.querySelector('[data-zct-zu]');
      if (zu) zu.focus({ preventScroll: true });
    } else {
      if (dr.contains(document.activeElement) && fokusVorher && fokusVorher.isConnected) fokusVorher.focus({ preventScroll: true });
      dr.removeAttribute('role'); dr.removeAttribute('aria-modal');
      dr.setAttribute('aria-hidden', 'true'); dr.setAttribute('inert', '');
    }
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (warenkorbOffen) warenkorbZu();
    if (merklisteOffen) merklisteZu();
  });
  // Bewegung komplett (Plan 004): Wischen zum Schließen für Schubladen am Touchgerät (emil-animate „Drag to dismiss“, emil-mobile-native).
  // Nur Touch und nur der erste Finger; erst ab 10 px und nur waagrecht (senkrechte Gesten bleiben Scrollen); das Panel folgt dem Finger direkt
  // (transform am Panel selbst), gegen die Schließrichtung mit Reibung; Loslassen schließt ab 30 % der Breite oder bei schnellem Wisch
  // (> 0,11 px/ms), sonst federt das Panel über seinen CSS-Übergang zurück. Eingabefelder und waagrecht scrollende Bereiche behalten ihre Geste.
  // Bewegung komplett (Plan 014, emil-mobile-native): iOS Safari setzt :active nur, wenn ein touchstart-Listener existiert.
  // Ohne ihn fehlte das Druck-Feedback (scale .97) auf dem iPhone komplett. Passiv, kostet nichts.
  document.addEventListener('touchstart', function () {}, { passive: true });
  // Fokusrahmen nur für Tastatur (im iOS-Simulator gefunden): Safari zeigt nach dem Antippen den Rahmen, wenn ein Skript den Fokus setzt
  // (Menü/Schublade öffnen und schließen). Nach Zeiger-Bedienung blenden Knöpfe und Links ihn aus, die erste Taste schaltet ihn wieder ein.
  document.addEventListener('pointerdown', function () { document.documentElement.classList.add('zd-zeiger'); }, { passive: true, capture: true });
  document.addEventListener('keydown', function () { document.documentElement.classList.remove('zd-zeiger'); }, { capture: true });
  window.zctWischZu = function (panel, o) {
    if (!panel || !window.PointerEvent || panel._zdWisch) return;
    panel._zdWisch = true;
    var vz = o.richtung === 'links' ? -1 : 1, start = null, dx = 0, aktiv = false, t0 = 0, breite = 1;
    function scrolltQuer(el) {
      for (; el && el !== panel; el = el.parentElement) { var cs = getComputedStyle(el); if (el.scrollWidth > el.clientWidth + 2 && /(auto|scroll)/.test(cs.overflowX)) return true; }
      return false;
    }
    function setzen(wert) { panel.style.setProperty('transform', wert, 'important'); }
    panel.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'touch' || start || e._zdWisch || !o.offen()) return;
      if (e.target.closest('input, textarea, select, [contenteditable]') || scrolltQuer(e.target)) return;
      e._zdWisch = true; // verschachtelte Panels (Unterpanel im Menü): das innere übernimmt die Geste
      start = { x: e.clientX, y: e.clientY, id: e.pointerId }; dx = 0; aktiv = false; t0 = performance.now(); breite = panel.getBoundingClientRect().width || 1;
    });
    panel.addEventListener('pointermove', function (e) {
      if (!start || e.pointerId !== start.id) return;
      var mx = e.clientX - start.x, my = e.clientY - start.y;
      if (!aktiv) {
        if (Math.abs(mx) < 10 && Math.abs(my) < 10) return;
        if (Math.abs(my) >= Math.abs(mx)) { start = null; return; }
        aktiv = true; t0 = performance.now();
        try { panel.setPointerCapture(e.pointerId); } catch (err) {}
        panel.style.setProperty('transition', 'none', 'important');
      }
      dx = mx * vz;
      var weg = dx >= 0 ? dx : dx / (1 + Math.abs(dx) / 40);
      setzen('translateX(' + (weg * vz) + 'px)');
    });
    function ende(e) {
      if (!start || (e && e.pointerId !== start.id)) return;
      var war = aktiv; start = null; aktiv = false;
      if (!war) return;
      var v = Math.abs(dx) / Math.max(1, performance.now() - t0);
      panel.style.removeProperty('transition'); panel.style.removeProperty('transform');
      if (dx > breite * 0.3 || (dx > 20 && v > 0.11)) o.zu();
    }
    panel.addEventListener('pointerup', ende);
    panel.addEventListener('pointercancel', ende);
  };
  function warenkorbAuf() { if (warenkorbOffen) return; warenkorbOffen = true; schubladeSetzen(document.querySelector('zct-warenkorb-schublade'), true); }
  function warenkorbZu() { warenkorbOffen = false; schubladeSetzen(document.querySelector('zct-warenkorb-schublade'), false); }
  function merklisteAuf() { merklisteOffen = true; schubladeSetzen(document.querySelector('zct-merkliste-schublade'), true); }
  function merklisteZu() { merklisteOffen = false; schubladeSetzen(document.querySelector('zct-merkliste-schublade'), false); }

  function schubladenWischen() {
    window.zctWischZu(document.querySelector('zct-warenkorb-schublade .drawer'), { richtung: 'rechts', offen: function () { return warenkorbOffen; }, zu: warenkorbZu });
    window.zctWischZu(document.querySelector('zct-merkliste-schublade .drawer'), { richtung: 'rechts', offen: function () { return merklisteOffen; }, zu: merklisteZu });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schubladenWischen); else schubladenWischen();
  function merkSpeichern() { try { localStorage.setItem(WISH_KEY, JSON.stringify(merkliste)); } catch (e) {} }
  function merken(id) {
    merkliste = merkliste.indexOf(id) >= 0 ? merkliste.filter(function (x) { return x !== id; }) : merkliste.concat([id]);
    merkSpeichern();
    melden();
  }

  // Günstigste lieferbare Variante eines Produkts (gleicher Preis wie „ab …“ in der Empfehlung); Zeile mit Shopifys Namen
  function guenstigste(p) {
    var vs = (p && p.varianten) || [], best = null;
    vs.forEach(function (v) { if (v.a !== false && v.p != null && (!best || v.p < best.p)) best = v; });
    return best || vs.find(function (v) { return v.a !== false; }) || vs[0] || null;
  }
  function zeileFuer(p, v) {
    var standard = v && (v.t === 'Default Title' || v.o1 === 'Default Title');
    return { id: p.id, variantId: v ? v.id : undefined, name: p.titel || p.name, tone: p.ton, img: p.img,
      price: v && v.p != null ? v.p / 100 : p.preis / 100, size: v ? (standard ? '' : v.o1 || '') : p.groesse0,
      finish: v ? (standard ? '' : v.o2 || '') : (p.toene || [])[0], qty: 1 };
  }
  // Empfehlung hinzufügen (Schublade und Warenkorb-Seite): günstigste Variante, Menge 1, Schublade öffnet (Stopp 2, Entscheidung 3)
  function empfehlungHinzu(id) {
    var p = produkt(id);
    if (p) hinzufuegen(zeileFuer(p, guenstigste(p)));
  }
  // wie checkoutWithNote in v21: erst die Notiz sicher speichern, nur dann zur Kasse
  function zurKasse(e) {
    e.preventDefault();
    if (zeilen().length === 0) return;
    notizSpeichern(notiz).then(function (ok) { if (ok) location.assign('/checkout'); });
  }

  class ZctWarenkorbSchublade extends HTMLElement {
    connectedCallback() {
      this.ab = new AbortController();
      var s = { signal: this.ab.signal };
      var self = this;
      var zeichnen = function () {
        var dr = self.querySelector('.drawer');
        if (dr) einsetzen(dr, warenkorbInnen());
      };
      zuhoerer.push(zeichnen);
      this.zeichnen = zeichnen;
      zeichnen();
      this.addEventListener('click', function (e) {
        var t = e.target;
        if (t.closest('.drawer-bg')) { warenkorbZu(); return; }
        if (t.closest('[data-zct-zu]')) { warenkorbZu(); return; }
        if (t.closest('[data-zct-zu-link]')) { warenkorbZu(); return; }
        var mb = t.closest('[data-zct-menge]');
        if (mb) { mengeAendern(mb.getAttribute('data-zct-menge'), mb.getAttribute('data-zct-wert')); return; }
        var em = t.closest('[data-zct-empfehlung]');
        if (em) { empfehlungHinzu(em.getAttribute('data-zct-empfehlung')); return; }
        if (t.closest('[data-zct-kasse]')) zurKasse(e);
      }, s);
      this.addEventListener('input', function (e) { if (e.target.classList.contains('cart-note-textarea')) notizAendern(e.target.value); }, s);
      this.addEventListener('focusout', function (e) { if (e.target.classList.contains('cart-note-textarea')) notizSpeichern(); }, s);
    }
    disconnectedCallback() {
      if (this.ab) this.ab.abort();
      var i = zuhoerer.indexOf(this.zeichnen); if (i >= 0) zuhoerer.splice(i, 1);
    }
  }

  class ZctMerklisteSchublade extends HTMLElement {
    connectedCallback() {
      this.ab = new AbortController();
      var self = this;
      var zeichnen = function () { var dr = self.querySelector('.drawer'); if (dr) einsetzen(dr, merklisteInnen()); };
      zuhoerer.push(zeichnen);
      this.zeichnen = zeichnen;
      zeichnen();
      this.addEventListener('click', function (e) {
        var t = e.target;
        if (t.closest('.drawer-bg') || t.closest('[data-zct-zu]')) { merklisteZu(); return; }
        var weg = t.closest('[data-zct-merk-weg]');
        if (weg) { merken(weg.getAttribute('data-zct-merk-weg')); return; }
        if (t.closest('a[href]')) merklisteZu();
      }, { signal: this.ab.signal });
    }
    disconnectedCallback() {
      if (this.ab) this.ab.abort();
      var i = zuhoerer.indexOf(this.zeichnen); if (i >= 0) zuhoerer.splice(i, 1);
    }
  }

  class ZctWarenkorbSeite extends HTMLElement {
    connectedCallback() {
      if (this.ab) return;
      this.ab = new AbortController();
      var s = { signal: this.ab.signal };
      var self = this;
      // Der Server hat die Seite schon gezeichnet: Schlüssel der Zeilen übernehmen, danach nur Unterschiede nachziehen
      schluesselMerken(this);
      this._zctGezeichnet = true;
      var zeichnen = function () { einsetzen(self, seiteInnen()); };
      zuhoerer.push(zeichnen);
      this.zeichnen = zeichnen;
      zeichnen();
      this.addEventListener('click', function (e) {
        var t = e.target;
        var mb = t.closest('[data-zct-menge]');
        if (mb) { mengeAendern(mb.getAttribute('data-zct-menge'), mb.getAttribute('data-zct-wert')); return; }
        var em = t.closest('[data-zct-empfehlung]');
        if (em) { empfehlungHinzu(em.getAttribute('data-zct-empfehlung')); return; }
        if (t.closest('[data-zct-kasse]')) zurKasse(e);
      }, s);
      this.addEventListener('input', function (e) { if (e.target.classList.contains('cart-note-textarea')) notizAendern(e.target.value); }, s);
      this.addEventListener('focusout', function (e) { if (e.target.classList.contains('cart-note-textarea')) notizSpeichern(); }, s);
    }
    disconnectedCallback() {
      if (this.ab) this.ab.abort();
      this.ab = null;
      var i = zuhoerer.indexOf(this.zeichnen); if (i >= 0) zuhoerer.splice(i, 1);
    }
  }

  // Öffnen aus der Kopfleiste und von überall (Knöpfe mit data-zct-warenkorb-auf / data-zct-merkliste-auf)
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-zct-warenkorb-auf]')) { warenkorbAuf(); return; }
    if (t.closest('[data-zct-merkliste-auf]')) { merklisteAuf(); }
  });
  // Nach dem Zurückspringen (Browser-Cache) den Warenkorb abgleichen
  window.addEventListener('pageshow', function (e) { if (e.persisted) abgleichen(null); });

  window.zctLaden = {
    produkte: PRODUKTE, produkt: produkt, fmt: fmt, bildUrl: bildUrl, bildSet: bildSet,
    add: hinzufuegen,
    quickAdd: function (p) {
      // wie quickAdd in v21: ohne Preis oder mit Auswahl zur Produktseite
      var x = typeof p === 'string' ? produkt(p) : p;
      if (!x) return;
      var groessen = x.groessenAnzahl || 1;
      if (x.preis == null || groessen > 1 || (x.toene || []).length > 1) { location.href = ROOT + '/products/' + encodeURIComponent(x.handle || x.id); return; }
      var z = zeileFuer(x, guenstigste(x)); delete z.img; hinzufuegen(z);
    },
    mengeAendern: mengeAendern, notizAendern: notizAendern, notizSpeichern: notizSpeichern,
    zeilen: zeilen, warenkorb: function () { return roh; },
    openCart: warenkorbAuf, closeCart: warenkorbZu, openWish: merklisteAuf, closeWish: merklisteZu,
    toggleWish: merken, wish: function () { return merkliste.slice(); },
    aufAenderung: function (f) { zuhoerer.push(f); }
  };

  if (!customElements.get('zct-warenkorb-schublade')) customElements.define('zct-warenkorb-schublade', ZctWarenkorbSchublade);
  if (!customElements.get('zct-merkliste-schublade')) customElements.define('zct-merkliste-schublade', ZctMerklisteSchublade);
  if (!customElements.get('zct-warenkorb-seite')) customElements.define('zct-warenkorb-seite', ZctWarenkorbSeite);
  melden();
})();
